import React from "react";
import { FormSection } from "redux-form";

import FixedDocumentProjectDetailsSection from "../sections/fixed/FixedDocumentProjectDetailsSection.jsx";
import FixedDocumentAuthorizationSection from "../sections/fixed/FixedDocumentAuthorizationSection.jsx";
import DefaultHighRiskActivitiesSection from "../sections/default/DefaultHighRiskActivitiesSection.jsx";
import DefaultRiskMatrixSection from "../sections/default/DefaultRiskMatrixSection.jsx";
import DefaultEmergencyContactsSection from "../sections/default/DefaultEmergencyContactsSection.jsx";
import DynamicSwmsContentManagementSection from "../sections/dynamic/DynamicSwmsContentManagementSection.jsx";
import DynamicMethodItemTypeSection from "../sections/dynamic/DynamicMethodItemTypeSection.jsx";
import JSASection2 from "../../JSASection2.jsx";

import { sectionBodyMessageByBucket } from "./JobSwmsFormV3SectionRegistry.config";

export default function renderSectionContent(sectionKey, sectionData, swmsData, loading, change, config, onCancelApprover, swmsStatus) {
  if (config.bucket === "fixed") {
    if (sectionKey === "document_project_details") {
      return (
        <FormSection
          component={FixedDocumentProjectDetailsSection}
          name={`sections.${sectionKey}.data`}
          sectionKey={sectionKey}
          sectionData={sectionData}
          swmsStatus={swmsStatus}
          swmsData={swmsData}
          loading={loading}
        />
      );
    }

    if (sectionKey === "document_authorization") {
      return (
        <FixedDocumentAuthorizationSection
          sectionKey={sectionKey}
          sectionData={sectionData}
          loading={loading}
          change={change}
          onCancelApprover={onCancelApprover}
        />
      );
    }
  }

  if (config.bucket === "default") {
    if (sectionKey === "high_risk_activities") {
      return (
        <FormSection
          component={DefaultHighRiskActivitiesSection}
          name={`sections.${sectionKey}.data`}
          sectionKey={sectionKey}
          sectionData={sectionData}
          loading={loading}
        />
      );
    }

    if (sectionKey === "risk_matrix") {
      return (
        <FormSection
          component={DefaultRiskMatrixSection}
          name={`sections.${sectionKey}.data`}
          sectionKey={sectionKey}
          sectionData={sectionData}
          swmsData={swmsData}
          loading={loading}
        />
      );
    }

    if (sectionKey === "emergency_contacts") {
      return (
        <FormSection
          component={DefaultEmergencyContactsSection}
          name={`sections.${sectionKey}.data`}
          sectionKey={sectionKey}
          sectionData={sectionData}
          loading={loading}
          change={change}
        />
      );
    }

    if (sectionKey === "job_steps_hazards_consequences_controls") {
      return (
        <FormSection
          component={JSASection2}
          name={`sections.${sectionKey}.data`}
          sectionKey={sectionKey}
          sectionData={sectionData}
          swmsData={swmsData}
          loading={loading}
          change={change}
        />
      );
    }
  }

  if (config.bucket === "method_item_type") {
    return (
      <FormSection
        component={DynamicMethodItemTypeSection}
        name={`sections.${sectionKey}.data`}
        sectionKey={sectionKey}
        sectionData={sectionData}
        swmsData={swmsData}
        loading={loading}
        change={change}
      />
    );
  }

  if (config.bucket === "swms_content_management") {
    return (
      <FormSection
        component={DynamicSwmsContentManagementSection}
        name={`sections.${sectionKey}.data`}
        sectionKey={sectionKey}
        sectionData={sectionData}
        loading={loading}
        change={change}
      />
    );
  }

  return (
    <div style={{ fontSize: "12px", color: "#475569", padding: "8px 0" }}>
      {sectionBodyMessageByBucket[config.bucket]}
    </div>
  );
}